import en from './en';
import es from './es';


const translations = {
  en: { translation: en },
  es: { translation: es },
}

export default translations;